import { Controller } from "@hotwired/stimulus"

// Optimistic UI for the heart button. Server response is a Turbo Frame
// replacement that swaps the partial back in with authoritative state, so
// any visual flip we do here is purely a perceived-latency improvement —
// the frame replacement will overwrite our changes if the server disagrees.
//
// Also handles propagation: heart sits inside an item-card whose root
// element has its own click handler that navigates away. Stopping the
// bubbling click at the form level keeps the navigation from racing the
// like submission.
export default class extends Controller<HTMLFormElement> {
  static targets = ["icon"]
  static values = {
    liked: Boolean,
  }

  declare readonly iconTarget: SVGElement
  declare readonly hasIconTarget: boolean
  declare likedValue: boolean

  stopBubble(event: Event) {
    event.stopPropagation()
  }

  optimisticFlip() {
    if (!this.hasIconTarget) return

    const nextLiked = !this.likedValue
    this.likedValue = nextLiked
    this.iconTarget.setAttribute("fill", nextLiked ? "currentColor" : "none")
    this.element.setAttribute("aria-label", nextLiked ? "Unlike" : "Like")
  }
}
